import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import UserItem from '../components/UserItem';
import { CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { ChevronLeft } from 'lucide-react';

function StalkersList() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const { userId: loggedInUserId } = useAuth();
  const isOwner = (loggedInUserId === userId);
  const [stalkers, setStalkers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStalkers = async () => {
    try {
      const res = await axiosInstance.get(`/profile/${userId}/stalkers`);
      setStalkers(res.data || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching stalkers:', err);
      setLoading(false);
    }
  };

  const removeStalker = async (stalkerId) => {
    try {
      await axiosInstance.delete(`/profile/${userId}/stalkers/${stalkerId}`);
      fetchStalkers();
    } catch (err) {
      console.error('Error removing stalker:', err);
    }
  };

  useEffect(() => {
    fetchStalkers();
  }, [userId]);

  if (loading) {
    return  (
      <div className="loading-container">
        <CircularProgress size={40} sx={{ color: '#d1d5db' }} />
      </div>
    );
  }

  return (
    <div>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft className="w-8 h-8" />
        </button>
        <h1 className="top-title">Stalkers</h1>
      </div>

      <div className="divide-y divide-gray-200 dark:divide-neutral-800 mx-2 mt-2">
        {stalkers.length > 0 ? (
          stalkers.map((user) => (
            <UserItem
              key={user.user_id}
              user={user}
              navigate={navigate}
              onRemove={isOwner ? () => removeStalker(user.user_id) : null}
            />
          ))
        ) : (
          <p className="px-4 py-10 text-center text-sm text-gray-500 dark:text-gray-400">No stalkers found.</p>
        )}
      </div>
    </div>
  );
}

export default StalkersList;
